import { render } from "./APIForm.vue?vue&type=template&id=7075941e&scoped=true"
import script from "./APIForm.vue?vue&type=script&lang=js"
export * from "./APIForm.vue?vue&type=script&lang=js"

import "./APIForm.vue?vue&type=style&index=0&id=7075941e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7075941e"]])

export default __exports__